import React from 'react';
import Projects from './Projects';
import ParentLayout from './ParentLayout';

export default function Layout(props) {
  return (
    <ParentLayout title="Projects">
      {function(params) {
        return (
          <>
            <Projects params={params} />
          </>
        );
      }}
    </ParentLayout>
  );
}
